window.NPS = window.NPS || {};
window.NPS.Views = window.NPS.Views || {};
window.NPS.Views.LinkEdit = window.NPS.Views.LinkEdit || {};
window.NPS.Views.LinkEdit.Views = window.NPS.Views.LinkEdit.Views || {};
window.NPS.Views.LinkEdit.Views['select/extended'] = (function($, _) {

    function view(editor, opts) {
        var
            self = this,
            opts = _.defaults({}, opts)
        ;
        this.editor = editor;
        this.$el = editor.$el.find('[data-page]');
        this.link = editor.link;
        this.extension = this.$el.data('extension');

        this.opts = opts;
    }

    view.prototype.$ = function (sp) {
        return this.$el.find(sp);
    };

    view.prototype.stage = function () {
        var self = this,
            $tree = self.$('.tree');

        $.get(this.opts.root + $tree.data('url'))
            .then(function(resp) {
                $tree.html(resp);
                return self;
            });

        self.$el.on('click.npseditorlinksSelectExtended', '.tree .node', function() {
            self.setNode($(this).data('node'));
        });
        self.$el.on('click.npseditorlinksSelectExtended', '.objects .element', function() {
            self.setSelection($(this));
        });

        return this;
    };
    view.prototype.unstage = function () {
        this.$el.off('.npseditorlinksSelectExtended');
        return this;
    };

    view.prototype.setNode = function (node) {
        var self = this,
            $objects = self.$('.objects'),
            $nodes = self.$('.tree').find('.node'),
            d
        ;

        this.node = node;

        $nodes.removeClass('selected');
        $nodes.filter('[data-node="' + node +'"]').addClass('selected');

        d = _.extend({}, this.opts.data, {nodeId: node});

        return $.get(this.opts.root + $objects.data('url'), d)
            .then(function(resp) {
                $objects.html(resp);
                return self;
            });
    };
    view.prototype.setSelection = function ($selection) {
        var self = this;

        if (self.$selection) {
            self.$selection.removeClass('selected');
        }
        $selection.addClass('selected');
        self.$selection = $selection;

        self.editor.enableNext('select/extended');

        return self;
    };

    view.prototype.commit = function () {
        var self = this;

        self.link.setProperty('link', self.$selection.data('link'));

        return self;
    };
    return function(editor, opts) {
        return new view(editor, opts);
    }

})(window.jQuery, window._);